import { ROUTE_EXTERNAL_CLAIM } from '@/constants/Routes'
import { Player } from '@/types'
import { HTMLProps, forwardRef } from 'react'
import { Link } from 'react-router-dom'
import PlayerItem from './PlayerItem'

export type PlayersProps = HTMLProps<HTMLDivElement> & {
  players: Player[]
  partnerId: string
}

export const Players = forwardRef<HTMLDivElement, PlayersProps>(({ players, partnerId, ...props }, ref) => {
  return (
    <div ref={ref} className="flex flex-col h-full w-full overflow-auto" {...props}>
      {players.map((player, i) => (
        <Link
          to={`${ROUTE_EXTERNAL_CLAIM}/${player.id}/${partnerId}`}
          state={{ claimDetail: player }}
          key={`${player.id}-${i}`}
        >
          <PlayerItem key={`${player.id}-${i}`} player={player} />
        </Link>
      ))}
    </div>
  )
})

export default Players
